import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/zh1';
export const locale = {
  lang: 'zh1',
  data: {
    'ODS': {
      'TITULO': '公司簡介',
      'TOOLBAR': {
        'NUEVA': '為公司創建配置文件',
        'EDITAR': '您可以修改該公司的資料數據',
        'CAMBIOS': '（更改會自動保存）',
        'DESCARGAR': '下載公司資料'
      },
      'FORMULARIOS': {
        '0': '公司信息',
        '1': '專案經理',
        '2': '人力資源總監',
        '3': '信息技術經理',
      },
      'BOTONES': {
        'BACK': '以前的',
        'NEXT': '下一個',
        'ACEPTAR': '接受'
      },
      'MODALES': {
        'EMPRESA_EXISTE': '已存在指定名稱的註冊公司，請嘗試使用其他名稱重新創建公司',
        'ERROR_GUARDADO': '創建公司時出錯，請稍後重試',
        'GUARDANDO': '保存更改',
        'GENERANDO_PDF': '正在生成 PDF 文件，請稍等'
      },
      'CAMPOS': {
        'institutoEmpresa': '經紀人',
        'country_application': '經紀人國家',
        'nombreEmpresa': '公司',
        'shortName': '公司簡稱',
        'nombrePublicacion': '出版公司名稱',
        'account_id': '帳戶ID',
        'idSalesForce': '銷售隊伍 ID',
        'codigoProyecto': '項目代碼',
        'anioFundacion': '預科年',
        'empleadosCompleto': '全職員工',
        'empleadosParcial': '兼職員工',
        'totalColaboradores': '合作者總數',
        'sector': '選擇一個部門',
        'subSector': '選擇子行業',
        'multinacional': '跨國',
        'name_multinational_group':'跨國集團名稱',
        'region': '選擇地區',
        'pais': '國家',
        'estado': '州、市或省',

        'nombreResponsable': '姓名',
        'apellidoResponsable': '姓',
        'emailResponsable': '電子郵件',
        'telResponsable': '電話',
        'extResponsable': '延期',
        'celResponsable': '移動的',

        'nombreRH': '全名',
        'emailRH': '電子郵件',
        'telRH': '電話',
        'extRH': '延期',
        'celRH': '移動的',

        'nombreTI': '全名',
        'emailTI': '電子郵件',
        'telTI': '電話',
        'extTI': '延期',
        'celTI': '移動的',

        'PDF_sector': '扇區',
        'PDF_subSector': '分部門',
        'PDF_region': '地區',
        'PDF_fecha': '日期：',
        'PDF_hora': '小時：',
      },
      'CATALOGOS': {
        'institutoEmpresa': catalogos.institutos,
        'sector': catalogos.sectores,
        'region': catalogos.regiones,
        'multinacional': {
          '1': '是的',
          '2': '不',
        }
      },
      'ERRORES': {
        'minlength': '您沒有輸入允許的最少字符數',
        'maxlength': '您已超過允許的最大字符數',
        'max': '輸入的數量超過了允許的最大值',
        'min': '輸入的數字小於所需的最小值',
        'pattern': '輸入的文本包含此字段中不允許的字符',
        'email': '輸入的文本不是正確的電子郵件格式',
        'required': '此字段是必需的',
        'TEXT_ESPEC_ANIOFUNDA':'輸入的日期超過了允許的最大值',
      }
    }
  }
};
